import React, {Component} from 'react';
import {UISTATES, KEYCODES} from '../enum';
import {Results} from './results';
import classnames from 'classnames';
import {resize} from '@homeaway/raf-optimized';
import CSSTransition from 'react-transition-group/CSSTransition';
import {SVGIcon} from '@homeaway/react-svg';
import {CLOSE__16} from '@homeaway/svg-defs';

export class Typeahead extends Component {
    componentDidMount() {
        this.clearResize = resize(this.onResize);
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.isTypeaheadInputFocus &&
            nextProps.isTypeaheadInputFocus !== this.props.isTypeaheadInputFocus
        ) {
            this.userInput.focus();
        }
    }

    componentDidUpdate() {
        this.sizePopover();
    }

    componentWillUnmount() {
        if (this.clearResize) {
            this.clearResize();
            this.clearResize = null;
        }
    }

    onResize = () => {
        this.sizePopover();
    };

    sizePopover() {
        const {isMobile, popoverDesktopWidth} = this.props;
        if (!isMobile && popoverDesktopWidth !== 'auto' && this.popover) {
            const oldWidth = Math.round(
                this.popover.getBoundingClientRect().width
            );
            const newWidth = this.getMaxWidth();
            if (newWidth !== oldWidth) {
                this.popover.style.width = `${newWidth}px`;
            }
        }
    }

    assignStateClass() {
        return ` state--${this.props.uistate}`;
    }

    isDestinationSelected() {
        return (
            !!this.props.selectedDestination &&
            this.props.uistate !== UISTATES.SELECT_DESTINATION
        );
    }

    getWindowWidth() {
        if (typeof window !== 'undefined') {
            return window.innerWidth;
        } else if (typeof document !== 'undefined') {
            return (
                document.documentElement.clientWidth ||
                document.body.clientWidth ||
                0
            );
        }
        return 0;
    }

    getMaxWidth() {
        const {popoverDesktopWidth, popoverDesktopMinMarginRight} = this.props;
        const popoverLeft = this.popover
            ? this.popover.getBoundingClientRect().left
            : 0;
        const parsedPopoverDesktopWidth = parseInt(popoverDesktopWidth, 10);
        const maxWidth = Math.max(
            200,
            Math.round(
                this.getWindowWidth() -
                    popoverLeft -
                    (popoverDesktopMinMarginRight || 0)
            )
        );
        return parsedPopoverDesktopWidth < maxWidth
            ? parsedPopoverDesktopWidth
            : maxWidth;
    }

    getPopoverWidthStyles() {
        const {
            isMobile,
            popoverDesktopWidth,
            popoverDesktopMinWidth,
            popoverDesktopMaxWidth
        } = this.props;
        if (isMobile) {
            return {width: '100%'};
        } else if (popoverDesktopWidth !== 'auto') {
            return {width: `${this.getMaxWidth()}px`};
        }
        return {
            minWidth: popoverDesktopMinWidth,
            maxWidth: popoverDesktopMaxWidth
        };
    }

    showResults = () => {
        let hasValidUIState =
            this.props.uistate === UISTATES.SELECT_DESTINATION;
        let hasValidSearch =
            (!!this.props.search && this.props.search.length > 0) ||
            this.props.isTrendingResults;
        let hasValidResults =
            this.props.results !== false &&
            (this.props.results && this.props.results.length !== 0);
        let hasSpinnerAndXhrPending =
            this.props.results === false &&
            this.props.showSpinner === true &&
            this.props.xhrPending === true;

        return (
            hasValidUIState &&
            !!hasValidSearch &&
            (hasValidResults || hasSpinnerAndXhrPending)
        );
    };

    showClearButton = () => {
        return !!this.props.search && this.props.search.length > 0;
    };

    renderResults() {
        if (this.showResults()) {
            return (
                <div
                    className="search-destination-results-container pop-up-container"
                    tabIndex="-1"
                    style={this.getPopoverWidthStyles()}
                    ref={this.setPopoverRef}
                >
                    <div className="pop-up-container__arrows">
                        <div className="pop-up-container__arrow__outer pop-up-container__arrow" />
                        <div className="pop-up-container__arrow__inner pop-up-container__arrow" />
                    </div>

                    <Results
                        selectDestinationIndex={
                            this.props.selectDestinationIndex
                        }
                        selectDestinationSubIndex={
                            this.props.selectDestinationSubIndex
                        }
                        results={this.props.results}
                        search={this.props.search}
                        useAnim={this.props.useResultsAnimation}
                        onSelectDestination={this.props.onSelectDestination}
                        onError={this.props.onError}
                        onBlur={this.handleBlur}
                        isMobile={this.props.isMobile}
                        messages={{
                            noresultsfound: this.props.messages.noresultsfound,
                            recentlyviewed: this.props.messages.recentlyviewed,
                            resultsfound: this.props.messages.resultsfound,
                            destinationselected: this.props.messages
                                .destinationselected,
                            trendingdestinations: this.props.messages
                                .trendingdestinations,
                            typeairport: this.props.messages.typeairport,
                            typecity: this.props.messages.typecity,
                            typelandmark: this.props.messages.typelandmark,
                            typeneighborhood: this.props.messages
                                .typeneighborhood,
                            typeregion: this.props.messages.typeregion,
                            typetrainstation: this.props.messages
                                .typetrainstation,
                            typemetrostation: this.props.messages
                                .typemetrostation
                        }}
                        showSpinner={this.props.showSpinner}
                        xhrPending={this.props.xhrPending}
                        poweredByGoogle={this.props.poweredByGoogle}
                        showResultIcons={this.props.showResultIcons}
                        showResultLabels={this.props.showResultLabels}
                        skipFilters={this.props.skipFilters}
                        filterType={this.props.filterType}
                        inputHasIcon={!!this.props.icon}
                        truncateResultTerms={this.props.truncateResultTerms}
                        highlightMode={this.props.highlightMode}
                        isTrendingResults={this.props.isTrendingResults}
                    />
                </div>
            );
        }
        return <div />;
    }

    handleFocus = (e) => {
        if (!this.props.isTypeaheadInputFocus) {
            this.props.onFocus(e);
            return true;
        }
        return false;
    };

    handleBlur = () => {
        this.userInput.blur();
        this.props.onBlur();
    };

    handleKeyDownOnClear = (e) => {
        if (e.keyCode === KEYCODES.ENTER || e.keyCode === KEYCODES.SPACE) {
            e.stopPropagation();
            e.preventDefault();
            this.props.onClear();
            return true;
        }
        return false;
    };

    setUserInputRef = (el) => {
        this.userInput = el;
    };

    setHeaderRef = (el) => {
        this.header = el;
    };

    setPopoverRef = (el) => {
        this.popover = el;
    };

    render() {
        // search is user input text, displayTerm is the destination label text
        let userInput = this.props.displayTerm || this.props.search;
        let inputEmpty = !(this.isDestinationSelected() || userInput);
        let placeholderText = inputEmpty
            ? this.props.messages.destinationplaceholdermsg
            : this.props.messages.where;
        let searchInputWrapperAttrs = {};
        searchInputWrapperAttrs['aria-controls'] = this.showResults()
            ? 'Typeahead__results'
            : null;

        return (
            <div
                className="search-destination-input"
                role="combobox" // eslint-disable-line jsx-a11y/role-has-required-aria-props
                aria-haspopup="listbox"
                aria-expanded={this.showResults()}
                {...searchInputWrapperAttrs}
            >
                <div
                    role="presentation"
                    className={`search-destination-input__header${this.assignStateClass()}`}
                    onClick={this.props.onClick}
                    ref={this.setHeaderRef}
                >
                    <div
                        className={classnames(
                            'search-destination-input__header__inputs',
                            'form-group',
                            'has-feedback',
                            'floating-label',
                            {
                                'not-empty': !inputEmpty,
                                'has-icon': this.props.icon
                            }
                        )}
                        data-toggle="label"
                    >
                        {this.props.uistate === UISTATES.SELECT_DESTINATION ? (
                            <input
                                aria-hidden
                                type="text"
                                size="10"
                                className="form-control hint"
                                value={this.props.searchSuggestion || ''}
                                readOnly
                                autoComplete="off"
                            />
                        ) : null}
                        <label htmlFor="react-destination-typeahead">
                            {placeholderText}
                        </label>
                        <input
                            type="text"
                            id="react-destination-typeahead"
                            size="10"
                            tabIndex="0"
                            placeholder={placeholderText}
                            className={classnames('control', 'form-control')}
                            onFocus={this.handleFocus}
                            onKeyDown={this.props.onKeyDown}
                            onChange={this.props.onChange}
                            onBlur={this.props.onBlur}
                            value={userInput}
                            autoComplete="off"
                            aria-autocomplete="both"
                            ref={this.setUserInputRef}
                        />
                        {this.props.icon ? (
                            <span className="form-control-icon search-destination-input__icon">
                                {this.props.icon}
                            </span>
                        ) : null}
                        {this.showClearButton() ? (
                            <button
                                aria-label={this.props.messages.clearsearch}
                                className="form-control-feedback search-destination-input__close"
                                tabIndex="0"
                                onClick={this.props.onClear}
                                onTouchEnd={this.props.onClear}
                                onKeyDown={this.handleKeyDownOnClear}
                            >
                                <SVGIcon markup={CLOSE__16} />
                            </button>
                        ) : null}
                    </div>
                </div>
                {this.props.usePopoverAnimation ? (
                    <CSSTransition
                        in={this.showResults()}
                        classNames="search-destination-results-container"
                        timeout={{enter: 250, exit: 250}}
                        mountOnEnter
                        unmountOnExit
                    >
                        {this.renderResults()}
                    </CSSTransition>
                ) : (
                    this.renderResults()
                )}
            </div>
        );
    }
}
